export const _1 = require('./1.png')
export const _1426 = require('./1426.png')
